export default "__VITE_ASSET__3c29ee64__"